import { render, staticRenderFns } from "./sales_charts1.vue?vue&type=template&id=98458a3c&scoped=true&"
import script from "./sales_charts1.vue?vue&type=script&lang=js&"
export * from "./sales_charts1.vue?vue&type=script&lang=js&"
import style0 from "./sales_charts1.vue?vue&type=style&index=0&id=98458a3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98458a3c",
  null
  
)

export default component.exports